import { useEffect } from 'react'

import { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { useAddBucketMutation } from '@/react-query/mutations/buckets'

import { type SchemaType, schema } from './AddBucketForm.schema'

export interface AddBucketFormProps extends Omit<UseFormProps<SchemaType>, 'resolver'> {
  children?: ((form: UseFormReturn<SchemaType>) => React.ReactNode) | React.ReactNode
  onSubmit?: SubmitHandler<SchemaType>
}

export const AddBucketForm: React.FC<AddBucketFormProps> = ({ children, onSubmit, ...props }) => {
  const form = useFormWithSchema({ mode: 'all', ...props }, schema)

  const addBucketMutation = useAddBucketMutation()

  const submit = form.handleSubmit(
    onSubmit ??
      (async (data, _e) => {
        await addBucketMutation.mutateAsync(data)
        form.reset()
      }),
  )

  useEffect(() => {
    form.trigger()
  }, [])

  return (
    <Form {...form}>
      <form onSubmit={submit}>{typeof children === 'function' ? children(form) : children}</form>
    </Form>
  )
}
